const ALLOWED_PREFIXES = ['/fitness-profiles/', '/dashboard', '/front-office', '/fitness-hub', '/ai-trainer', '/challenge-wire', '/community-challenges/', '/friends', '/linked-households'];

export function safeReturnTo(value) {
	if (!value || typeof value !== 'string') return null;

	const path = value.startsWith('/') ? value : null;
	if (!path) return null;
	if (path.startsWith('//')) return null;

	const allowed = ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix));
	return allowed ? path : null;
}

export function returnToFromSearch(search) {
	const params = new URLSearchParams(search || '');
	return safeReturnTo(params.get('returnTo'));
}
